export enum EDrawerTypes {
    CREATE_AUTOMATION = 'CREATE_AUTOMATION',
    UPDATE_AUTOMATION = 'UPDATE_AUTOMATION',
    CREATE_SEARCH = 'CREATE_SEARCH',
}